import { ReactNode } from 'react';
import { Navigate, Route } from 'react-router-dom';
// import Segments from '../pages/components/segments/Segments';
import ChangePassword from '@/pages/auth/ChangePassword';
import SessionExpired from '@/pages/auth/SessionExpired';
import ServiceMonitor from '@/components/manage/sys/monitor/ServiceMonitor';

type CustomRoute = {
  path: string;
  element: ReactNode;
  key: string;
};

/**
 * Array of custom route configurations for the application.
 * These routes will be rendered outside of the standard resource routes.
 */
const customRoutes: CustomRoute[] = [
  // {
  //   path: '/segments',
  //   element: <Segments />,
  //   key: 'segments',
  // },
  // Add more custom routes here as needed
  {
    path: '/changePassword',
    element: <ChangePassword />,
    key: 'changePassword',
  },
  {
    path: '/change-password',
    element: <Navigate to="/changePassword" replace />,
    key: 'change-password-redirect',
  },
  {
    path: '/session-expired',
    element: <SessionExpired />,
    key: 'session-expired',
  },
  {
    path: '/service-monitor',
    element: <ServiceMonitor />,
    key: 'service-monitor',
  },
];

/**
 * Renders all custom routes as an array of Route components.
 * This can be used within a Routes or CustomRoutes component.
 */
const renderCustomRoutes = () => {
  return customRoutes.map((route) => (
    <Route
      key={route.key}
      path={route.path}
      element={route.element}
    />
  ));
};

export { customRoutes, renderCustomRoutes };
export type { CustomRoute };
